
import { onMounted, ref } from "vue";
import gsap from "gsap";
import { mapGetters } from "vuex";
import { ElScrollbar } from 'element-plus'
import { duration } from 'moment';
export default {
  name: "PopularBooks",
  components:{
    ElScrollbar
  },
  data() {
    return {
      isActive: false
    };
  },
  
  computed: {
    ...mapGetters(["getBestSellers"]),
    bestSellers() {
      const books = this.getBestSellers.books;
      if (!books || !books.length) {
        return null;
      } else {
        return books.slice(0, Math.min(books.length, 20));
      }
    },
  },
  setup() {
    let tl = gsap.timeline({ defaults: {ease: "power4.inOut", duration: 2}})
    onMounted(() => {
    tl.from('#card', {scaleY: 0, stagger: .2 })
  }
)},
  mounted() {
    this.$store.dispatch("fetchBestSellers");
    const loading = ref(true);
  },
  methods:{
    isLoaded: function() {
            this.isActive = true;
      },
      enter() {
      gsap.to('#group', {
        scrollTrigger: "#group",
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
        duration: 1
      })
    },
    pageTransition(){
      let tl = gsap.timeline();
      tl.to("#loader",{
        duration: 1.2, width:"100%", left:"0%", ease: "Expo.easeInOut"
      })
      tl.to("#loader",{
        duration: 1, width:"100%", left:"100%", ease:"Expo.easeInOut", delay:0.3, 
      })
      tl.set("#loader", {
        left:"-100%", 
      })
    }
  }
};
